import { useCallback } from 'react'

import { DirectLinkSource } from '../../searchForCare/constants'
import { TOOLKIT_TYPE } from '../../wellnessToolkit/types'

interface useNavigateToWellnessToolkitArgs {
  setToolkitType: (toolkitPromotion: TOOLKIT_TYPE) => void
  setDirectLinkSource: (directLinkSource: DirectLinkSource) => void
  navigateToToolkit: (
    toolkitPromotion: TOOLKIT_TYPE,
    navigationParams?: { onBackPressed?: () => void; mixpanelEntryPoint?: string },
  ) => void
}

/**
 * Hook that handles setting state variable needed for toolkit navigation
 */
export const useNavigateToWellnessToolkit = ({
  setToolkitType,
  setDirectLinkSource,
  navigateToToolkit,
}: useNavigateToWellnessToolkitArgs) => {
  return useCallback(
    ({
      toolkitPromotion,
      directLinkSource,
      navigationParams,
    }: {
      toolkitPromotion: TOOLKIT_TYPE
      directLinkSource: DirectLinkSource
      navigationParams?: { onBackPressed?: () => void; mixpanelEntryPoint?: string }
    }) => {
      setToolkitType(toolkitPromotion)
      setDirectLinkSource(directLinkSource)

      navigateToToolkit(toolkitPromotion, navigationParams)
    },
    [navigateToToolkit, setDirectLinkSource, setToolkitType],
  )
}
